import useFetch from '@hooks/useFetch';
import { HOST_TYPE } from '@utils/api-helper/host';
import { emptyObject } from '@constants/empty';
import { useRouter } from 'next/router';

export const getKey = (eventKey) => `api/prodigy-tests/${eventKey}`;
export const getDailyScholarshipKey = (eventKey) =>
  `api/daily-scholarship-tests/${eventKey}`;

const useScholarshipTestInfo = (
  eventKey,
  options = {
    revalidateOnMount: false,
    fallbackData: undefined
  }
) => {
  const { pathname } = useRouter();
  const isDstPage = pathname.includes('dailyscholarship');
  const key = isDstPage ? getDailyScholarshipKey(eventKey) : getKey(eventKey);

  const { data: prodigyInfo, ...rest } = useFetch(
    key,
    {
      hostType: HOST_TYPE.CMS
    },
    {
      revalidateOnMount: options.revalidateOnMount,
      fallbackData: options.fallbackData
    }
  );

  return {
    key,
    prodigyInfo: prodigyInfo || emptyObject,
    ...rest
  };
};

export default useScholarshipTestInfo;
